import { render } from "./CreateGitTokenDialog.vue?vue&type=template&id=06ddbdc1"
import script from "./CreateGitTokenDialog.vue?vue&type=script&lang=js"
export * from "./CreateGitTokenDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__